<template>
  <div
    class="d-flex align-items-center flex-fill w-100 w-md-auto"
  >
    <div class="d-flex flex-wrap align-items-center">
      <span
        v-if="parents && !showManualEnter"
        class="text-primary cursor-pointer"
        @click="backToParent(null)"
      >
        {{ bucketName }}
      </span>
      <span
        v-else
        class="text-main"
        @click="initManualPath"
      >
        {{ bucketName }}
      </span>

      <template v-if="parents && !showManualEnter">
        <div
          v-for="(parent, index) in parents"
          :key="`${parent}-${index}`"
          class="d-flex align-items-center cursor-pointer"
        >
          <GjIcon
            name="ArrowRight"
            size="14"
            style="margin:0 5px; flex: none;"
          />
          <span
            v-if="index === parents.length - 1"
            class="text-main text-break cursor-pointer"
            @click="initManualPath"
          >
            {{ parent || '[Empty name]' }}
          </span>
          <span
            v-else
            class="text-primary directory-breadcrumb cursor-pointer"
            @click="backToParent(index)"
          >
            {{ parent || '[Empty name]' }}
          </span>
        </div>
      </template>
    </div>
    <span
      v-if="!showManualEnter"
      class="text-main cursor-pointer"
      style="margin-left:5px;"
      @click="initManualPath"
    >
      <b-icon-search />
    </span>
    <template v-if="showManualEnter">
      <div class="position-relative d-flex align-items-center flex-fill">
        <span>
          /
        </span>
        <b-input
          ref="filePathInput"
          v-model="manualEnterPath"
          class="m-0 p-0 files-path w-full flex-fill"
          placeholder="..."
          type="text"
          @keyup.enter="goToManualPath"
          @blur="hideManualEnter"
        />
      </div>
    </template>
    <b-spinner
      v-if="gettingObject || deletingObject || refreshingObjects"
      class="loadingFolder mx-1"
      variant="primary"
    />
  </div>
</template>

<script>
import { BIconSearch } from 'bootstrap-vue'

export default {
  name: 'DirectoryBreadcrumbs',
  components: {
    BIconSearch,
  },
  props: {
    activeKey: {
      type: String,
      default: '',
    },
    parents: {
      type: Array,
      default: null,
    },
    bucketName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showManualEnter: false,
      manualEnterPath: '',
    }
  },
  computed: {
    gettingObject() {
      return this.$store.state.accountObjects.gettingObject
    },
    deletingObject() {
      return this.$store.state.accountObjects.deletingObject
    },
    refreshingObjects() {
      return this.$store.state.accountObjects.refreshingObjects
    },
  },
  watch: {
    activeKey(val) {
      this.manualEnterPath = val
      if (this.showManualEnter) {
        this.$refs.filePathInput.blur()
      }
    },
    showManualEnter(val) {
      if (val) {
        setTimeout(() => {
          if (this.$refs.filePathInput) {
            this.$refs.filePathInput.focus()
          }
        }, 200)
      }
    },
  },
  created() {
    this.manualEnterPath = this.activeKey
  },
  methods: {
    goToManualPath() {
      this.$emit('goToManualPath', this.manualEnterPath)
      this.hideManualEnter()
    },
    backToParent(index) {
      if (index !== undefined && index !== null) {
        const tempParents = [...this.parents]
        const path = `${tempParents.splice(0, index + 1).join('/')}/`
        this.$emit('backToParent', path)
      } else {
        this.$emit('backToParent', null)
      }
    },
    initManualPath() {
      this.showManualEnter = true
    },
    hideManualEnter() {
      if (this.showManualEnter) {
        this.showManualEnter = false
        this.manualEnterPath = this.activeKey
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.loadingFolder {
  height: 1.4rem;
  width: 1.4rem;
}
.directory-breadcrumb {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
